import { constants } from '../../constants';

const styles = {
    container: {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: 30,
        marginRight: 30,
    },
    iconStyle: {
        color: constants.color.primary,
        marginRight: 15,
    },
    itemContainer: {
        alignItems: 'center',
        display: 'flex',
        paddingBottom: 8,
    },
    listItemStyle: { 
        color: '#5C5C5C',
        fontFamily: 'Open Sans',
        fontSize: 20,
        fontWeight: '300',
        lineHeight: 1, 
        whiteSpace: 'pre-line',
    },
    mainTitleContainer: {
        fontFamily: 'Open Sans',
        fontSize: 40,
        fontWeight: '700',
    },
    title: {
        color: '#7B7B7B',
        fontFamily: 'Open Sans',
        fontSize: 25,
        fontWeight: '300',
        marginBottom: 10
    },
}

export { styles as listStyles };


// WEBPACK FOOTER //
// ./src/js/components/List/styles.ts